// Default monster base stats. Inlined here (rather than imported from
// Classes/utils/constants) to avoid a circular import:
// constants.js itself uses createMonster to build the MONSTERS dict.
const DEFAULT_MONSTER_STATS = { health: 20, maxHealth: 25, mana: 10, maxMana: 15 };

// Returns a plain, isolated monster object.
// Each call produces fresh stats/attack/position/inventory references so two
// monsters never share state via prototype or shared refs (which was the case
// when Monster was a class instantiated at module load with a shared
// `this.stats = BASE_STATS.MONSTER`).
export const createMonster = ({
    name,
    type,
    inventory,
    skin,
    level = 1,
    attack,
    expDrop = 20,
    stats,
} = {}) => ({
    name,
    type,
    skin,
    level,
    expDrop,
    stats: stats ? { ...stats } : { ...DEFAULT_MONSTER_STATS },
    attack: attack ? { ...attack } : { name: 'droite monumentale', type: 'physical', damage: 3 },
    inventory: inventory ? { ...inventory } : {},
    position: { mapId: 'map1', x: 0, y: 0 },
});
